module.exports = __webpack_public_path__ + "72f1aa023c1f5cff852679fc27ce632d.png";